import { render, staticRenderFns } from "./gz_video_library.vue?vue&type=template&id=865fd8ae"
import script from "./gz_video_library.vue?vue&type=script&lang=js"
export * from "./gz_video_library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports